import { render, staticRenderFns } from "./pack-class.vue?vue&type=template&id=51fbd382&"
import script from "./pack-class.vue?vue&type=script&lang=js&"
export * from "./pack-class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports